<!--<div *ngIf="isStaging" class="staging-banner">-->
<!--    Uwaga: Jesteś w środowisku STAGING!-->
<!--</div>-->
<app-header *ngIf="authService.isLoggedIn()" [isStaging]="isStaging" class="fixed-header"></app-header>
<!--<app-header *ngIf="authService.isLoggedIn()" class="fixed-header"></app-header>-->
<app-notifications></app-notifications>
<div [ngClass]="{'container-fluid': authService.isLoggedIn()}">
    <router-outlet></router-outlet>
</div>
